export default __webpack_public_path__ + "static/media/IBimageAnklestiffness3.bec623ca.png";